<h1
  class="   ff-title-s ff-bold title-bar"
>
<div class="title-text">{{ title | translate }}
      <ds-icon *ngIf="icon" icon="{{icon}}" icon-size="xlarge" icon-filled="false"></ds-icon>
</div>

  <div class="title-actions">
    <app-upl-doc-btn
      class="title-action"
      [type]="type"
      [numeroOrdine]="numeroOrdine"
      [ngStyle]="{ visibility: !uploadDisabled ? 'visible' : 'hidden' }"
    ></app-upl-doc-btn>

    <ng-container *ngIf="buttonTemplate && !actionsDisabled">
      <ng-container *ngTemplateOutlet="buttonTemplate"></ng-container>
    </ng-container>
  </div>
</h1>
